class BlockUIConfiguration {
    static config (blockUIConfig) {
        blockUIConfig.autoInjectBodyBlock = true;
        blockUIConfig.templateUrl = 'app/overlay.html';
        blockUIConfig.requestFilter = (config) => config.url.indexOf("/api/") > 0 || config.url.indexOf("/auth/") > 0;
    }
}

BlockUIConfiguration.config.$inject = ['blockUIConfig'];

export default BlockUIConfiguration;


// WEBPACK FOOTER //
// ./app/block-ui.configuration.js